<template>
  <div>
    <b-table :data="venues" :bordered="false" :striped="true" :hoverable="true">
      <template slot-scope="props">

        <b-table-column field="name" label="Name"><b>{{ props.row.name }}</b></b-table-column>

        <b-table-column field="address" label="Address" centered>
          {{ props.row.address }}
        </b-table-column>

        <b-table-column field="website" label="Website" centered>
          <a v-bind:href="props.row.website">{{props.row.website}}</a>
        </b-table-column>

        <b-table-column label="Edit">
          <button class="button is-small ">
            <b-icon pack="fas" :icon="'edit'" @click.native="editVenue(props.row)"></b-icon>
          </button>
        </b-table-column>


        <b-table-column label="Delete">
          <button class="button is-danger is-small ">
            <b-icon pack="fas" :icon="'trash'" type="is-light" @click.native="editVenue(props.row)"></b-icon>
          </button>
        </b-table-column>

      </template>
    </b-table>
    <b-field grouped position="is-right">
      <p class="control addButton">
        <button class="button is-primary" @click="newVenue">Add new venue</button>
      </p>
    </b-field>
    <b-modal :active.sync="isNewVenueDialog" has-modal-card @close="getVenues">
      <CreateVenue :venue="selectedVenue"></CreateVenue>
    </b-modal>
  </div>
</template>

<script>
import BModal from "buefy/src/components/modal/Modal";
import CreateVenue from "./CreateVenue";

export default {
  name: "Venues",
  components: { CreateVenue, BModal },
  data() {
    return {
      venues: [],
      isNewVenueDialog: false,
      selectedVenue: {},
    };
  },
  methods: {
    editVenue: function(venue) {
      this.selectedVenue = venue;
      this.isNewVenueDialog = true;
    },
    newVenue: function() {
      this.selectedVenue = {};
      this.isNewVenueDialog = true;
    },
    getVenues: function(){
        this.$store
        .dispatch("getVenues")
        .then(() => (this.venues = this.$store.getters.venues))
        .catch(err => console.log(err));
    }
  },
  mounted() {
      this.getVenues()
  }
};
</script>

<style scoped>
.ddialog {
  min-width: 400px;
}
</style>
